import PropTypes from 'prop-types'
import { cx } from '@emotion/css'

const FontIcon = ({ alt = '', children, className = '', theme, value, ...other }) => (
  <span
    data-react-toolbox='font-icon'
    aria-label={alt}
    className={cx(
      {
        'material-icons': typeof value === 'string' || typeof children === 'string',
      },
      className
    )}
    {...other}>
    {value}
    {children}
  </span>
)

FontIcon.propTypes = {
  alt: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  theme: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
}

export default FontIcon
export { FontIcon }
